import axios from "axios";

const baseURL = "https://web-production-3590.up.railway.app/";

const axiosForgetPasswordInstance = axios.create({
  baseURL: baseURL,
  timeout: 5000,
  headers: {
    "Content-Type": "application/json",
    accept: "application/json",
  },
});

export default axiosForgetPasswordInstance;
